import * as React from "react";
import ImageGallery  from "./ImageGallery";

export function BrandStory() {
  return (
    <div className="flex flex-col bg-customBg">
      {/* <BrandDescription />
      <VideoSection /> */}
      <ImageGallery />
    </div>
  );
}